export default __webpack_public_path__ + "static/media/mumbai.3b822836.png";